import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import '../../comicstyle.css';

export class MultipleChoice extends Component {
    static displayName = MultipleChoice.name;

    constructor(props) {
        super(props);

        this.state = { selectedAnswerId: null };

        this.selectAnswer = this.selectAnswer.bind(this);
        this.confirmAnswer = this.confirmAnswer.bind(this);
        
    }

    selectAnswer(selectedId) {
        this.setState({ selectedAnswerId: selectedId });
    }

    confirmAnswer() {
        if (this.state.selectedAnswerId !== null) {
            this.props.onConfirmAnswer(this.state.selectedAnswerId);
        }
    }
    
    render() {
        return (
            <Container className="multichoiceComponent">

                {this.props.imageUrl ? <Row>
                    <div className="col-sm">
                        <div className="multichoiceImage d-none d-sm-block">
                            <img src={this.props.imageUrl} alt="" />
                        </div>
                        <div className="multichoiceImage-mobile d-block d-sm-none pb-3">
                            <img src={this.props.imageUrl} alt="" />
                        </div>
                    </div>
                </Row> : <Row className="py-5 d-none d-sm-block"></Row> }

                {this.props.children}

                <Row>
                    <div className="col-sm">
                        <div className="parallelogram d-none d-sm-block">
                            <div className="parallelogram-content">
                                {this.props.question}
                            </div>
                        </div>
                        <div className="parallelogram-mobile d-block d-sm-none">
                            {this.props.question}
                        </div>
                    </div>
                </Row>
                <Row className="align-items-end">
                    <Col xs="12" sm="10">
                        <ul className="multichoiceAnswerList" >
                            {
                                this.props.answerOptions.map((answerOptions) => {
                                    var selectedClassName = answerOptions.id === this.state.selectedAnswerId ? "selectedAnwser" : "";
                                    return (
                                        <li key={answerOptions.id} className={"multichoiceAnswerItem " + selectedClassName} onClick={() => this.selectAnswer(answerOptions.id)}>
                                            <div className="multichoiceAnswerItemContainer">
                                                <span className="multichoiceAnswerItemInner">
                                                    {answerOptions.optionText}
                                                </span>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </Col>
                    <Col xs="12" sm="2">
                        <div onClick={this.confirmAnswer} className={this.state.selectedAnswerId !== null ? "nextButton" : "nextButton grayedOut"}>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

MultipleChoice.propTypes = {
    question: PropTypes.string.isRequired,
    answerOptions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        optionText: PropTypes.string
    })).isRequired,
    imageUrl: PropTypes.string,
    onConfirmAnswer: PropTypes.func.isRequired,
};

MultipleChoice.defaultProps = {
    question: "Dit is een standaard vraag omdat de property 'question' van het 'MultipleChoice' component niet is gezet." ,
    answerOptions: [
        { id: 1, optionText: "Dit is een standaard antwoord tekst omdat de property 'answerOptions' van het 'MultipleChoice' component niet is gezet." },
        { id: 3, optionText: "Dit is een standaard antwoord tekst omdat de property 'answerOptions' van het 'MultipleChoice' component niet is gezet." },
        { id: 4, optionText: "Dit is een standaard antwoord tekst omdat de property 'answerOptions' van het 'MultipleChoice' component niet is gezet." },
        { id: 5, optionText: "Dit is een standaard antwoord tekst omdat de property 'answerOptions' van het 'MultipleChoice' component niet is gezet." },
    ],
     imageUrl: "/img/foetsie.jpg",
    onConfirmAnswer: () => {console.log("ERROR, onConfirmAnswer prop not set");}
};

